var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"description":_vm.errorMsg}})
}
var staticRenderFns = []

export { render, staticRenderFns }